<template>
    <div 
        :key="key" 
        :class="{'component-label-custom-disabled' : disabled}" 
        class="component-label-custom"
        @click="click">
        {{ state ? "默认查询" : "高级查询" }}
    </div>
</template>

<script>
export default {
  name: "AdvanceDefaultQuerySwtich",
  
  inheritAttrs: false,

  props: {
    value: {
      default: false,
      type: Boolean
    },

    label: {
      default: "",
      type: String
    },

    disabled: {
      default: false,
      type: Boolean
    }
  },

  data() {
    return {
      key: `AdvanceDefaultQuerySwtichID-${Math.random()
        .toString(36)
        .slice(2)}`
    };
  },

  computed: {
    state: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit("input", val);
        this.$emit("change", val);
      }
    }
  },

  methods: {
    click() {
      if (this.disabled) return;
      this.state = !this.state;

      this.$emit("advance", this.state);
    }
  }
};
</script>

<style lang="scss">
.component-label-custom {
  display: inline-block;
  font-size: 14px !important;
  cursor: pointer;
  vertical-align: middle;
  height: 30px;
  line-height: 30px;
  margin-left: 30px;
  &:hover {
    color: #29a1f0;
  }
}
.component-label-custom-disabled {
  color: #c0c4cc !important;
  cursor: not-allowed !important;
  opacity: 0.75 !important;
}
</style>
